var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.portalUpdatesJan2026Enabled && _setup.showCapture)?_c(_setup.AllAnalyticsCapture,{ref:"captureRef",attrs:{"homepage-sections":_vm.homepageSections,"page-extras":_vm.pageExtras,"homepage-busy":_vm.homepageBusy}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }